import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LogOut, Zap, ArrowLeft } from 'lucide-react';
import { PostAPI } from '../../ApiServices/ApiServices';
import AppContext from '../../Context/AppContext';
import './Subscription.css';
import { openCashfreeCheckout } from '../../Utils/cashfreeCheckout';

const Subscription = () => {
    const navigate = useNavigate();
    const { setUser } = useContext(AppContext);

    // Steps: plan_selection | trial_success | billing_details | payment_method | subscription_success
    const [step, setStep] = useState("plan_selection");
    const [selectedMethod, setSelectedMethod] = useState("UPI");
    const [autoPay, setAutoPay] = useState(true);
const doctorData = JSON.parse(localStorage.getItem("doctorData"));


const createSubscription = (isTrial) => {
  PostAPI(
    {
      url: `/subscription/${doctorData.id}?plan_id=DIGIDOC_MONHTLY_ONDEMAND&is_trial=${isTrial}`,
      data: {},
    },
    async (res) => {
      if (!res.success) {
        toast.error(res.message || "Something went wrong");
        return;
      }

      const sessionId = res.response?.subscription_session_id;
      const subscriptionId = res.response?.subscription_id; 

      if (!sessionId) {
        toast.error("Subscription session ID not found.");
        return;
      }

      // ✅ MUST save BEFORE opening checkout
      localStorage.setItem("subscription_id", subscriptionId);
      localStorage.setItem("is_trial", isTrial);

      console.log("saved subscription_id:", subscriptionId); // ← check this log

      await openCashfreeCheckout(sessionId);
    }
  );
};
    const handleLogout = async () => {
        try {
            await PostAPI({ url: "/auth/doctor/logout" }, () => {});
        } catch (e) { console.error(e); } finally {
            setUser({ type: "logout" });
            sessionStorage.removeItem("loggedIn");
            sessionStorage.removeItem("subscribed");
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("doctorData");
            navigate("/");
        }
    };

    const handleProceedToDashboard = () => {
        sessionStorage.setItem("subscribed", "true");
        setUser({ type: "subscribe" });
        const doctorData = JSON.parse(localStorage.getItem("doctorData") || "{}");
        navigate(doctorData?.profile_status ? "/profile" : "/");
    };

    const fmt = (date) => {
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
    };
    const today = fmt(new Date());
    const trialEnd = fmt(new Date(Date.now() + 14 * 864e5));
    const renewalDate = (() => { const d = new Date(); d.setMonth(d.getMonth()+1); return fmt(d); })();

    const features = [
        "Appointment Management", "Patient EMR", "Consultation Management",
        "Prescription Management", "Automated Follow-ups", "Patient Communication Management"
    ];
    const paymentMethods = ["UPI", "Credit Card", "Debit Card", "Net Banking"];

    const SignOutLink = () => (
        <div className="text-center mt-3">
            <a
  href="#"
  className="text-danger text-decoration-underline fw-semibold d-inline-flex align-items-center gap-1"
  onClick={(e) => {
    e.preventDefault();
    handleLogout();
  }}
>
  <LogOut size={14} /> Sign Out
</a>
        </div>
    );

    return (
        <div className="login-for container">
            <div className="right-content">
                <p className="wel-content">
                    <span className="color-txt">
                        {step === "plan_selection" ? "Subscription Required" :
                         step === "trial_success"  ? "Trial Flow" :
                         step === "billing_details" ? "Billing Details" :
                         step === "payment_method"  ? "Payment Gateway" : "Success"}
                    </span>
                </p>
                <h4 className="form-head fw-bold mb-4">
                    {step === "plan_selection"       ? "Choose Your Plan" :
                     step === "trial_success"         ? "Trial Activated" :
                     step === "billing_details"       ? "Review Invoice" :
                     step === "payment_method"        ? "Checkout" : "Purchase Confirmed"}
                </h4>
            </div>

            {/* ── PLAN SELECTION ──────────────────────────────── */}
            {step === "plan_selection" && (
                <div className="card shadow-sm plan-card-border p-2">
                    <div className="card-body">
                        <h5 className="card-title fw-bold fs-4 mb-3">Clinic Plan</h5>
                        <p className="fs-5 fw-semibold mb-4">₹ 999 <span className="text-muted fw-normal fs-6">/ Month</span></p>

                        <p className="fw-semibold mb-2">Features Included:</p>
                        <ul className="list-unstyled mb-4">
                            {features.map((f, i) => (
                                <li key={i} className="d-flex align-items-start gap-2 mb-2 fw-medium">
                                    <span className="fw-bold mt-1">✓</span> {f}
                                </li>
                            ))}
                        </ul>

                      <button
  className="btn bg-dg c-w w-100 py-2 fw-semibold mb-2 d-flex align-items-center justify-content-center gap-2"
  style={{ border: "none" }}
  onClick={() => createSubscription(false)}
>
  <Zap size={16} fill="currentColor" />
  Activate Clinic Plan
</button>

{doctorData.existSubscription?.status !== "CANCELLED" && (
  <button
    className="btn bor-dg c-dg w-100 py-2 fw-semibold"
    onClick={() => createSubscription(true)}
  >
    Start 14-Day Free Trial
  </button>
)}
                        <SignOutLink />
                    </div>
                </div>
            )}

            {/* ── TRIAL SUCCESS ───────────────────────────────── */}
            {step === "trial_success" && (
                <div className="card shadow-sm plan-card-border p-2">
                    <div className="card-body">
                        <h5 className="fw-bold fs-5 mb-4">🎉 Trial Activated Successfully</h5>
                        <p className="fw-semibold fs-5 mb-4">Clinic Plan Trial</p>

                        <p className="text-muted small fw-semibold mb-1">Trial Start Date:</p>
                        <p className="fw-medium mb-3">{today}</p>
                        <p className="text-muted small fw-semibold mb-1">Trial End Date:</p>
                        <p className="fw-medium mb-3">{trialEnd}</p>
                        <p className="fw-bold fs-5 mb-4">14 Days Remaining</p>

                        <button className="btn bg-dg c-w w-100 py-2 fw-semibold"
                            style={{ border: "none" }}
                            onClick={handleProceedToDashboard}>
                            Proceed to Portal
                        </button>
                        <SignOutLink />
                    </div>
                </div>
            )}

            {/* ── BILLING DETAILS ──────────────────────────────── */}
            {step === "billing_details" && (
                <div className="card shadow-sm plan-card-border p-2">
                    <div className="card-body">
                        <button className="btn btn-link text-secondary text-decoration-none ps-0 mb-3 d-flex align-items-center gap-1 fw-semibold"
                            onClick={() => setStep("plan_selection")}>
                            <ArrowLeft size={16} /> Back to Plans
                        </button>

                        <h5 className="fw-bold fs-4 mb-4">Clinic Plan</h5>

                        <p className="text-muted small fw-semibold mb-1">Billing Cycle:</p>
                        <p className="fw-medium mb-3">Monthly</p>
                        <p className="text-muted small fw-semibold mb-1">Amount:</p>
                        <p className="fw-medium mb-4">₹ XXXX</p>

                        <button className="btn bg-dg c-w w-100 py-2 fw-semibold"
                            style={{ border: "none" }}
                            onClick={() => setStep("payment_method")}>
                            Proceed to Payment
                        </button>
                        {/* <SignOutLink /> */}
                    </div>
                </div>
            )}

            {/* ── PAYMENT METHOD ───────────────────────────────── */}
            {step === "payment_method" && (
                <div className="card shadow-sm plan-card-border p-2">
                    <div className="card-body">
                        <button className="btn btn-link text-secondary text-decoration-none ps-0 mb-3 d-flex align-items-center gap-1 fw-semibold"
                            onClick={() => setStep("billing_details")}>
                            <ArrowLeft size={16} /> Back to Invoice
                        </button>

                        <h5 className="fw-bold fs-5 mb-3">Choose Payment Method</h5>
                        <div className="d-flex flex-column gap-2 mb-3">
                            {paymentMethods.map((m) => (
                                <div key={m}
                                    className={`payment-option d-flex align-items-center gap-2 border rounded p-2 ${selectedMethod === m ? "selected" : ""}`}
                                    onClick={() => setSelectedMethod(m)}>
                                    <input type="radio" name="pay_method" id={`pm_${m}`}
                                        className="form-check-input m-0"
                                        checked={selectedMethod === m}
                                        onChange={() => setSelectedMethod(m)} />
                                    <label htmlFor={`pm_${m}`} className="form-check-label fw-medium mb-0" style={{ cursor: "pointer" }}>{m}</label>
                                </div>
                            ))}
                        </div>

                        <p className="text-muted small fw-semibold mb-1">Total Payable:</p>
                        <p className="fw-bold fs-5 mb-3">₹ XXXX</p>

                        <div className="form-check mb-4">
                            <input type="checkbox" className="form-check-input" id="sub_autopay"
                                checked={autoPay} onChange={(e) => setAutoPay(e.target.checked)} />
                            <label className="form-check-label fw-semibold" htmlFor="sub_autopay">Auto Pay</label>
                        </div>

                        <button className="btn bg-dg c-w    w-100 py-2 fw-semibold"
                            style={{border: "none" }}
                            onClick={() => { toast.success("Payment received! Activating plan..."); setStep("subscription_success"); }}>
                            Pay Now
                        </button>
                        {/* <SignOutLink /> */}
                    </div>
                </div>
            )}

            {/* ── SUBSCRIPTION SUCCESS ─────────────────────────── */}
            {step === "subscription_success" && (
                <div className="card shadow-sm plan-card-border p-2">
                    <div className="card-body">
                        <h5 className="fw-bold fs-5 text-success mb-4">✓ Subscription Activated</h5>
                        <p className="fw-semibold fs-5 mb-4">Clinic Plan Active</p>

                        <p className="text-muted small fw-semibold mb-1">Subscription Start:</p>
                        <p className="fw-medium mb-3">{today}</p>
                        <p className="text-muted small fw-semibold mb-1">Next Renewal:</p>
                        <p className="fw-medium mb-3">{renewalDate}</p>
                        <p className="fw-semibold text-success mb-4">Invoice Generated Successfully</p>

                        <button className="btn bg-dg c-w w-100 py-2 fw-semibold"
                            style={{ border: "none" }}
                            onClick={handleProceedToDashboard}>
                            Proceed to Portal
                        </button>
                        <SignOutLink />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Subscription;
